import { createTheme } from "@mui/material";

export const actionContrast = {
  action: {
    active: '#FFFFFF',
    activeOpacity: 1,
    // hover: '',
    // hoverOpacity: 1,
    // focus: '',
    // focusOpacity: 1,
    // selected: '',
    // selectedOpacity: 1,
  }
}

export const palette = {
  primary: {
    main: '#870052',
    contrastText: '#FFFFFF',
  },
  secondary: {
    main: '#111827',
  },
  action: {
    active: '#111827',
    activeOpacity: 1,
    // hover: '',
    // hoverOpacity: 1,
    // focus: '',
    // focusOpacity: 1,
    // selected: '',
    // selectedOpacity: 1,
  },
  divider: '#344054',
}

const theme = createTheme({
  palette,
  typography: {
    fontFamily: [
      'Inter',
      'Arial',
      'sans-serif'
    ].join(','),
    h1: {
      fontSize: '30px',
      fontWeight: 700,
      lineHeight: '39px',
      padding: '16px 20px',
      color: '#344054',
    },
    h3: {
      fontSize: '16px',
      fontWeight: 600,
      lineHeight: '24px',
      color: '#667085',
    },
    h2: {
      fontSize: '18px',
      fontWeight: 600,
      lineHeight: '28px',
      color: '#101828',
    },
    body1: {
      fontSize: '14px',
      fontWeight: 400,
      lineHeight: '17.5px',
      color: '#101828'
    },
    body2: {
      fontSize: '14px',
      fontWeight: 400,
      lineHeight: '20px',
      color: '#D1D5DB',
    },
    button: {
      fontSize: '14px',
      fontWeight: 600,
      letterSpacing: 0,
      lineHeight: '20px',
      color: '#111827'
    }
  },
  components: {
    MuiTypography: {
      defaultProps: {
        variantMapping: {
          h1: 'h2',
          h2: 'h2',
          h3: 'h2',
          h4: 'h2',
          h5: 'h2',
          h6: 'h2',
          subtitle1: 'h2',
          subtitle2: 'h2',
          body1: 'p',
          body2: 'p',
        },
      }
    },
    MuiDivider: {
      styleOverrides: {
        root: {
          width: '100%',
          margin: '32px 0',
        }
      }
    },
  }
});

export default theme;